
import React from 'react'

import moment from 'moment'

import { Table, Space } from "antd";


export default function DailySubTable({ data, loading, columns }) {


    // replace first element in array with this object 
    // the original one is monthly
    // this one is daily

    const day_column = {
        title: 'Giorni',
        dataIndex: 'key_as_string',
        key: 'key_as_string',
        render: (text, row) => (
            <Space size="middle" key={row.key}>
                <p>{moment(row.key_as_string).format("DD MMMM YYYY")}</p>
            </Space>
        ),
    }

    columns.splice(0, 1, day_column);

    if (loading) return <p> sto caricando ... </p>

    return <Table columns={columns}
        dataSource={data}
        pagination={true} />;

} 
